<template>
<div class="edit">
  <div class="edit_top">
    <router-link to="/devices/edit" class="edit_router">
      {{edit}}
    </router-link>
  </div>
  <div class="detail">
    <div class="detail_contents">
      <div class='detail_top'>
        <div class="device_name_label detail_label">
          {{deviceNameLabel}}
        </div>
        <div class="device_name detail_top_title">
          {{device.deviceName}}
        </div>
      </div>
      <div class="detail_bottom">
        <div class="device_id_label detail_label">
          {{deviceIdLabel}}
        </div>
        <div class="device_id">
          {{device.deviceId}}
        </div>
        <div class="phone_number_label detail_label">
          {{phoneNumberLabel}}
        </div>
        <div class="phone_number">
          {{device.phoneNumber2}}
        </div>
        <div class="create_date_time_label detail_label">
          {{createDateTimeLabel}}
        </div>
        <div class="create_date_time">
          {{device.createDateTime}}
        </div>
        <div class="last_update_date_time_label detail_label">
          {{lastUpdateDateTimeLabel}}
        </div>
        <div class="last_update_date_time">
          {{device.lastUpdateDateTime}}
        </div>
        <div class="user_name_label detail_label">
          {{userNameLabel}}
        </div>
        <div class="user_name">
          {{device.userName}}
        </div>
        <div class="user_id_label detail_label">
          {{userIdLabel}}
        </div>
        <div class="user_id">
          {{device.userId}}
        </div>
        <div class="device_status_label detail_label">
          {{deviceStatusLabel}}
        </div>
        <div class="device_status">
          {{device.deviceStatus}}
        </div>
        <div class="personal_device_flag_label detail_label">
          {{personalDeviceFlagLabel}}
        </div>
        <div class="personal_device_flag">
          {{personalDeviceFlag}}
        </div>
        <div class="call_app_label detail_label">
          {{callAppLabel}}
        </div>
        <div class="call_app">
          {{callApp}}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      edit: '編集',
      deviceNameLabel: '端末名',
      deviceIdLabel: '端末ID',
      phoneNumberLabel: '電話番号',
      createDateTimeLabel: '登録日時',
      lastUpdateDateTimeLabel: '最終アクセス',
      userNameLabel: 'ログインユーザ名',
      userIdLabel: 'ログインユーザID',
      deviceStatusLabel: '使用状況',
      personalDeviceFlagLabel: '端末区分',
      callAppLabel: '連携アプリ'
    }
  },
  computed: {
    device () {
      return this.$store.state.devices.device
    },
    personalDeviceFlag () {
      if (this.$store.state.devices.device.personalDeviceFlag) {
        return '個人端末'
      } else {
        return '共用端末'
      }
    },
    callApp () {
      for (let i = 0; i < this.$store.state.masters.masterData.callAppList.length; i++) {
        if (this.$store.state.masters.masterData.callAppList[i].id === this.device.callAppDivision) {
          return this.$store.state.masters.masterData.callAppList[i].callAppName
        }
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/deviceDetail.vue